import React, { useState,useEffect } from 'react'

import   './set_supplier.css'
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import SaveIcon from '@mui/icons-material/Save';
import CancelIcon from '@mui/icons-material/Cancel';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import Checkbox from "@mui/material/Checkbox";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import swal from 'sweetalert';

import {makeStyles} from '@mui/styles';

import { add_offer_call,update_offer_call } from '../../../../services/purchase_service';


  const useStyles = makeStyles((theme) => ({
    indeterminateColor: {
      color: "#f50057"
    },
    selectAllText: {
      fontWeight: 500
    },
    selectedAll: {
      backgroundColor: "rgba(0, 0, 0, 0.08)",
      "&:hover": {
        backgroundColor: "rgba(0, 0, 0, 0.08)"
      }
    }
  }));
  
  const ITEM_HEIGHT = 48;
  const ITEM_PADDING_TOP = 8;
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 250
      }
    },
    getContentAnchorEl: null,
    anchorOrigin: {
      vertical: "bottom",
      horizontal: "center"
    },
    transformOrigin: {
      vertical: "top",
      horizontal: "center"
    },
    variant: "menu"
  };
  

function Set_supplier({suppliersEdit,handleClose,open,formData,update,setOffers,clickOffre,offers,suppliers,setFormData,handleCloseAdd,setOffers_added}){

    const classes = useStyles();
    let user = JSON.parse(localStorage.getItem('user-info'));

    const [valide, setValid] = useState(true);
    const [submitted, setSubmitted] = useState(false);

    const [selected, setSelected] = useState([]);
    const [selectedId, setSelectedId] = useState([]);

    const [waiting, setWaiting] = useState(false);

    useEffect(()=>{
      if(suppliersEdit!=""){
        let tmp_array = [];
        suppliersEdit.split(',').map((id_supplier) => {
          suppliers.map((supplier) => {
            if(supplier.id == id_supplier) tmp_array.push(supplier.fullName);
          });
        });
        setSelected(tmp_array);
        setSelectedId(suppliersEdit.split(','));
      }

      //console.log(offers);

    },[])


    function id_supplier_parNom(noms){
      let id=[];
      suppliers.map((supplier) => {
        noms.map((nom) => {
          if(supplier.fullName == nom) id.push(supplier.id);
        });
          
      });
      return id;
    }

    function validated_elem(){
        return submitted && valide;
    }

    const isAllSelected =
        suppliers.length > 0 && selected.length === suppliers.length;

    const handleChange = (event) => {
        const value = event.target.value;
        if (value[value.length - 1] === "all") {
          let tmp_array = [];
          let tmp_id_array = [];
          suppliers.map((supplier) => {
              tmp_array.push(supplier.fullName);
              tmp_id_array.push(supplier.id);
          })
          setSelected(selected.length === suppliers.length ? [] : tmp_array);
          setSelectedId(selected.length === suppliers.length ? [] : tmp_id_array);
          return;
        }
        setSelected(value);
        //console.log(value);
        setSelectedId(id_supplier_parNom(value));
    };

    async function add_proposal() {   
        setWaiting(true); 
        setSubmitted(true);
        setValid(true);
        if (selected.length==0) {
          setWaiting(false); 
             setValid(false);
        }else{
          let tmp_form = formData;
          tmp_form.append('suppliers',selectedId);
          setFormData(tmp_form);
          if( update !== true ){
            add_offer_call(tmp_form).then((response) => {
              setWaiting(false); 
              swal("L'appel d'offre a été créé avec succès, les fournisseurs seront bientôt notifiés !", {
                icon: "success",
                buttons: true,
              }).then((willDelete) => {
                  if (willDelete) { setOffers_added(response.data);
              }})      
              handleClose();
              handleCloseAdd();
            }).catch((error) => {
              //console.log(error.response);
              setWaiting(false); 
            });
          }else{
            update_offer_call(tmp_form).then((response) => {
                setWaiting(false);
                swal("L'appel d'offre a été mis à jour avec succès, les fournisseurs seront bientôt notifiés !", {
                  icon: "success",
                  buttons: true,
                }).then((willDelete) => {
                    if (willDelete) { 
                      const arr=[...offers];
                      arr[clickOffre]=response.data;
                      setOffers(arr);
                    }
                  })
                
                handleClose();
            }).catch((error) => {
                //console.log(error.response);
                setWaiting(false);
            });
          }
          
        }
     }

    

    return (
      <>
        <Dialog fullWidth={true} maxWidth={'md'} open={open} onClose={handleClose} aria-labelledby="form-dialog-title" >
            <DialogTitle id="form-dialog-title">Liste des fournisseurs</DialogTitle>
            <DialogContent>
            <FormControl variant='standard' className="multi_form_select">
                <InputLabel id="mutiple-select-label">Fournisseurs</InputLabel>
                <Select
                    labelId="mutiple-select-label"
                    multiple
                    value={selected}
                    onChange={handleChange}
                    renderValue={(selected) => selected.join(", ")}
                    MenuProps={MenuProps}
                >
                    <MenuItem
                      value="all"
                      classes={{
                          root: isAllSelected ? classes.selectedAll : ""
                      }}
                      >
                      <ListItemIcon>
                          <Checkbox
                          classes={{ indeterminate: classes.indeterminateColor }}
                          checked={isAllSelected}
                          indeterminate={
                              selected.length > 0 && selected.length < suppliers.length
                          }
                          />
                      </ListItemIcon>
                      <ListItemText
                          classes={{ primary: classes.selectAllText }}
                          primary="Tout sélectionner"
                      />
                    </MenuItem>
                    {
                      suppliers.map((option) => (
                        <MenuItem key={option.id} value={option.fullName}>
                            <ListItemIcon>
                              <Checkbox checked={selected.indexOf(option.fullName) > -1} />
                            </ListItemIcon>
                            <ListItemText primary={option.parentCompany +" - "+option.fullName} />
                        </MenuItem>
                      ))
                    }
                </Select>
                </FormControl>
                
            </DialogContent>
        <DialogActions>
            <div className='dialogBottom'>
                <div>
                    {
                        validated_elem() 
                        ?<></>
                        :<p className={submitted ? "col-md-10 error" : "col-md-10 valid-champ"}>
                                {submitted ? "Sélectionner au moin un fournisseur !" : ""}
                            </p>
                    }
                </div>
              <div className='dialogSuppliersBottom'>
                  <Button variant="contained" className="submit_but cancel_but" startIcon={<CancelIcon />} onClick={handleClose} >
                      Annuler
                  </Button>
                  <Button variant="contained" className="submit_but valide_but" startIcon={<SaveIcon />} onClick={add_proposal} >
                      { update ? "Enregister" : "Ajouter" }
                  </Button>
              </div>
            </div>
        </DialogActions>
         <Backdrop
            sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
            open={waiting}
        >
            <CircularProgress color="inherit" />
        </Backdrop>
      </Dialog>
     
    </>
    )
}

export default Set_supplier
